"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemNotification = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const displayNotification = ({ body, onClick, iconPath, title }) => {
    if (!global.Notification) {
        return;
    }
    const notification = new global.Notification(title, {
        icon: iconPath,
        body,
    });
    notification.onclick = () => {
        onClick();
        notification.close();
    };
};
const SystemNotification = (_a) => {
    var _b;
    var { showNotification } = _a, props = __rest(_a, ["showNotification"]);
    // only show when the user has granted permission to the browser
    if (showNotification && ((_b = global.Notification) === null || _b === void 0 ? void 0 : _b.permission) === 'granted') {
        displayNotification(props);
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
exports.SystemNotification = SystemNotification;
//# sourceMappingURL=system_notification.js.map